import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Home from './pages/Home';
import DayTripListing from './pages/DayTripListing/DayTripListing';
import Fleets from './pages/Fleets';
import SkiTransfersPage from './pages/SkiTransferListing/SkiTransferListing';
import PrivateTourListing from './pages/PrivateTourListing/PrivateTourListing';
import About from './pages/About';
import Booking from './pages/Booking';
import Profile from './pages/profile pill modal/Profile';
import ProfileNotifications from './pages/profile pill modal/Notifications';
import SavedPlaces from './pages/profile pill modal/SavedPlaces';
import MyTrips from './pages/profile pill modal/MyTrips';
import MeetingBoardPage from './pages/MeetingBoardPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import CancellationPolicy from './pages/legal/CancellationPolicy';
import ScrollToTop from './components/ScrollToTop';
import TripReviewAutoPrompt from './components/TripReviewAutoPrompt';
import WhatsAppButton from './components/WhatsAppButton';
import {
  DashboardPage,
  DriversPage,
  CustomersPage,
  EnquiryPage,
  MyBookingsPage,
  NotificationsPage,
  PaymentsPage,
  ServicesPage,
  VehicleCategoriesBrandsPage,
  FleetFormPage,
  ServiceFormPage,
  NewBookingPage,
  NewDriverPage,
  ProfileSettingsPage,
  dashboardRoutes,
} from './dashboard';
import { AdminProtectedRoute } from './dashboard/components/auth/AdminProtectedRoute';
import AdminLoginPage from './dashboard/pages/auth/AdminLoginPage';
import { DashboardBadgeProvider } from './dashboard/context/DashboardBadgeContext';
import { ConfirmDialogProvider } from './dashboard/context/ConfirmDialogContext';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <TripReviewAutoPrompt />
      <WhatsAppButton />
      <Toaster position="bottom-center" />
        <DashboardBadgeProvider>
          <ConfirmDialogProvider>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/day-trips" element={<DayTripListing />} />
            <Route path="/fleets" element={<Fleets />} />
            <Route path="/ski-transfers" element={<SkiTransfersPage />} />
            <Route path="/private-tours" element={<PrivateTourListing />} />
            <Route path="/about" element={<About />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/notifications" element={<ProfileNotifications />} />
            <Route path="/saved-places" element={<SavedPlaces />} />
            <Route path="/my-trips" element={<MyTrips />} />
            <Route path="/meeting-board" element={<MeetingBoardPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cancellation-policy" element={<CancellationPolicy />} />
            <Route path="/cancellation" element={<CancellationPolicy />} />

            {/* Admin Login Route */}
            <Route path="/admin-login" element={<AdminLoginPage />} />

            {/* Protected Dashboard Routes */}
            <Route element={<AdminProtectedRoute />}>
              <Route path={dashboardRoutes.overview} element={<DashboardPage />} />
              <Route path={dashboardRoutes.bookings} element={<MyBookingsPage />} />
              <Route path={dashboardRoutes.bookingNew} element={<NewBookingPage />} />
              <Route path={dashboardRoutes.bookingEdit} element={<NewBookingPage />} />
              <Route path={dashboardRoutes.drivers} element={<DriversPage />} />
              <Route path={dashboardRoutes.driverNew} element={<NewDriverPage />} />
              <Route path={dashboardRoutes.driverEdit} element={<NewDriverPage />} />
              <Route path={dashboardRoutes.customers} element={<CustomersPage />} />
              <Route path={dashboardRoutes.services} element={<ServicesPage />} />
              <Route
                path={dashboardRoutes.vehicleCategoriesBrands}
                element={<VehicleCategoriesBrandsPage />}
              />
              <Route path={dashboardRoutes.fleetNew} element={<FleetFormPage />} />
              <Route path={dashboardRoutes.fleetEdit} element={<FleetFormPage />} />
              <Route path={dashboardRoutes.serviceNew} element={<ServiceFormPage />} />
              <Route path={dashboardRoutes.serviceEdit} element={<ServiceFormPage />} />
              <Route path={dashboardRoutes.payments} element={<PaymentsPage />} />
              <Route path={dashboardRoutes.enquiry} element={<EnquiryPage />} />
              <Route path="/dashboard/enquiries" element={<EnquiryPage />} />
              <Route path="/dashboard/feedback" element={<Navigate to={dashboardRoutes.enquiry} replace />} />
              <Route path={dashboardRoutes.notifications} element={<NotificationsPage />} />
              <Route path={dashboardRoutes.profile} element={<ProfileSettingsPage />} />

              {/* Compatibility aliases for the old admin URL namespace. */}
              <Route path="/admin/dashboard" element={<DashboardPage />} />
              <Route path="/admin/bookings" element={<MyBookingsPage />} />
              <Route path="/admin/services" element={<ServicesPage />} />
              <Route path="/admin/users" element={<Navigate to={dashboardRoutes.overview} replace />} />
            </Route>
          </Routes>
          </ConfirmDialogProvider>
        </DashboardBadgeProvider>
    </Router>
  );
}

export default App;
